<template>
  <v-form ref="form" class="px-6 mt-4">
    <p class="text-subtitle-1 font-weight-bold">Phân loại</p>
    <v-select
      outlined
      dense
      :items="studentTypeOptions"
      item-value="value"
      item-title="text"
      v-model="type"
      label="Phân loại"
    />
    <p class="text-subtitle-1 font-weight-bold">Thông tin & Đăng nhập</p>
    <v-text-field
      :rules="[rules.required]"
      v-model="name"
      label="Họ và Tên"
      @blur="nameLostFocus()"
      outlined
      dense
    ></v-text-field>
    <v-text-field
      :rules="[rules.required]"
      v-model="username"
      disabled
      label="Mã Học Sinh"
      outlined
      dense
    ></v-text-field>
    <v-text-field
      :rules="[rules.required]"
      v-model="phone"
      label="Số điện thoại"
      outlined
      dense
    ></v-text-field>
    <v-text-field
      v-model="email"
      label="Email"
      :error-messages="emailError"
      :rules="[rules.required]"
      @blur="emailLostFocus()"
      validate-on-blur
      outlined
      dense
    ></v-text-field>
    <v-text-field
      v-model="password"
      label="Mật Khẩu"
      :append-icon="show ? 'visibility' : 'visibility_off'"
      :rules="[rules.required, rules.min]"
      :type="show ? 'text' : 'password'"
      @click:append="show = !show"
      hint="At least 6 characters"
      outlined
      dense
    ></v-text-field>
    <p class="text-subtitle-1 font-weight-bold">Trung Tâm</p>
    <autocomplete-generation
      v-if="!hideAdvanceOption"
      v-model="generation"
      item-text="name"
      item-value="id"
      label="Khóa"
      return-object
      required
      outlined
      dense
    ></autocomplete-generation>
    <autocomplete-major
      v-if="!hideAdvanceOption"
      v-model="rootMajor"
      item-text="title"
      item-value="id"
      label="Chuyên Ngành"
      return-object
      required
      outlined
      dense
    ></autocomplete-major>
    <v-select
      v-if="!hideAdvanceOption"
      v-model="major"
      :items="majors"
      item-text="title"
      return-object
      item-value="id"
      label="Chuyên Ngành Hẹp"
      required
      outlined
      dense
    ></v-select>
    <autocomplete-class
      v-model="classes"
      item-text="title"
      item-value="id"
      label="Xếp Lớp"
      return-object
      required
      outlined
      multiple
      dense
    />
  </v-form>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import AutocompleteMajor from '@/components/basic/input/AutocompleteRootMajor.vue'
import AutocompleteGeneration from '@/components/basic/input/AutocompleteGeneration'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass.vue'
import { get } from 'lodash'
import { studentTypeOptions } from '../../helpers'
export default {
  components: {
    AutocompleteMajor,
    AutocompleteGeneration,
    AutocompleteClass
  },
  data() {
    return {
      dialog: false,
      loading: 0,
      name: '',
      type: this.$route.query.type,
      major: '',
      classes: [],
      rootMajor: {},
      generation: '',
      phone: '',
      email: '',
      lastemail: '',
      username: '',
      username_indexing: '',
      username_no: 0,
      role: '',
      show: false,
      password: '',
      emailError: '',
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 6 || 'Min 8 characters',
        email: v => /.+@.+/.test(v) || 'E-mail must be valid'
      }
    }
  },
  props: {
    hideAdvanceOption: Boolean,
    defaultPhone: String,
    defaultEmail: String,
    defaultName: String
  },
  computed: {
    ...mapState('app', ['roles', 'department']),
    ...mapGetters('app', ['roleIdByName', 'roles']),
    studentTypeOptions,
    isLoading() {
      return this.loading > 0
    },
    majors() {
      return this.rootMajor.majors || []
    }
  },
  methods: {
    ...mapActions('user', ['generateUserName', 'validateEmail']),
    ...mapActions('students', ['createStudent']),
    getData() {
      if (!this.$refs.form.validate()) return
      return {
        name: this.name,
        type: this.type,
        phone: this.phone + '',
        majors: [this.major.id].filter(m => !!m),
        classes: this.classes.map(c => c.id),
        rootMajor: get(this.rootMajor, 'id'),
        generation: get(this.generation, 'id'),
        username: this.username,
        username_indexing: this.username_indexing,
        username_no: this.username_no,
        status: 'active',
        role: this.roleIdByName('Student'),
        department: this.department.id,
        email: this.email,
        password: this.password
      }
    },
    async nameLostFocus() {
      const {
        username,
        // eslint-disable-next-line
        username_indexing,
        // eslint-disable-next-line
        username_no
      } = await this.generateUserName(this.name)
      this.username = username
      // eslint-disable-next-line
      this.username_indexing = username_indexing
      // eslint-disable-next-line
      this.username_no = username_no
    },
    async emailLostFocus() {
      try {
        this.loading += 1
        if (this.email !== this.lastemail) {
          this.emailError = await this.validateEmail(this.email)
        }
        this.lastemail = this.email
      } finally {
        this.loading -= 1
      }
    },
    cancel() {
      this.dialog = false
      this.reset()
    },
    reset() {
      this.name = ''
      this.username = ''
      this.phone = ''
      this.status = 'active'
      this.password = ''
      this.email = ''
      this.major = ''
      this.classes = []
      this.rootMajor = {}
      this.generation = []
    }
  },
  watch: {
    state(state) {
      this.dialog = true
      this.phone = this.defaultPhone || ''
      this.email = this.defaultEmail || ''
      this.name = this.defaultName || ''
      if (this.defaultName) {
        this.nameLostFocus()
      }
    },
    rootMajor() {}
  }
}
</script>
